import { Effect } from "../Materials/effect";
var name = 'filterPixelShader';
var shader = "\nvarying vec2 vUV;\nuniform sampler2D textureSampler;\nuniform mat4 kernelMatrix;\nvoid main(void)\n{\nvec3 baseColor=texture2D(textureSampler,vUV).rgb;\nvec3 updatedColor=(kernelMatrix*vec4(baseColor,1.0)).rgb;\ngl_FragColor=vec4(updatedColor,1.0);\n}";
Effect.ShadersStore[name] = shader;
/** @hidden */
export var filterPixelShader = { name: name, shader: shader };
//# sourceMappingURL=filter.fragment.js.map